import { useQuery } from 'react-query';
import styled from 'styled-components';
import { useMediaQuery } from '@mui/material';
import BenefitCard from 'src/components/BenefitCard';
import BenefitsService from 'src/services/BenefitsService';
import BenefitHeroSlideService from 'src/services/BenefitHeroSlideService';
import { Carousel, Header } from 'src/components';
import { useScrollToTop } from 'src/hooks';
import { arrayOfNumbers } from 'src/utils/array';
import { isNativePlatform } from '../../config';
import { Benefit } from 'src/models/Benefit/Benefit';
import BenefitsHero from './BenefitsHero';
import { Grid, PageStack } from './styles';

const desktopSkeletonCount = 4;
const mobileSkeletonCount = 2;

type CardItem = {
  id: string | number;
  benefit?: Benefit;
};

const EmptyCopy = styled.p`
  margin: 16px 0 0;
  font-size: 16px;
  line-height: 150%;
  color: ${p => p.theme.palette.text.low};
`;

const BenefitsLibrary: React.FC = () => {
  useScrollToTop();
  const isDesktop = useMediaQuery('(min-width: 768px)');
  const { data: benefits = [], isFetching: benefitsLoading } = useQuery(
    ['BenefitsLibrary'],
    () => BenefitsService.getMany(),
    { refetchOnWindowFocus: false },
  );
  const { data: hero, isFetching: heroLoading } = useQuery(
    ['BenefitHeroCopy'],
    () => BenefitHeroSlideService.get(),
    { refetchOnWindowFocus: false },
  );

  const skeletonCount = isDesktop ? desktopSkeletonCount : mobileSkeletonCount;
  const cards: CardItem[] = benefitsLoading
    ? arrayOfNumbers(skeletonCount).map((index) => ({ id: index }))
    : benefits.map((benefit) => ({ id: benefit.id, benefit }));
  const showCards = benefitsLoading || benefits.length > 0;
  const isEmpty = !benefitsLoading
    && !heroLoading
    && !hero
    && benefits.length === 0;

  return (
    <PageStack>
      {!isNativePlatform && <Carousel page="benefits" />}
      <BenefitsHero hero={hero} />
      {showCards && (
        <Grid>
          {cards.map((card) => (
            <BenefitCard key={card.id} benefit={card.benefit} />
          ))}
        </Grid>
      )}
      {isEmpty && (
        <div>
          <Header title="Twoje benefity" as="h1" />
          <EmptyCopy>Wkrótce pojawią się tu Twoje benefity.</EmptyCopy>
        </div>
      )}
    </PageStack>
  );
};

export default BenefitsLibrary;
